import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom-v5-compat';

import { useFeatureToggle } from '~/platform/utilities/feature-toggles';
import { DEFAULT_APPEAL_TAB } from '../../constants';
import { searchWithTab } from '../../utils/appeals-v2-helpers';

// Catch-all for unknown /appeals/:id/* subpaths (typos, stale bookmarks) that
// the status/detail routes don't match. Recovers to the appeal's default view
// instead of the blank page these URLs render today. The flag only changes the
// URL shape: ?tab=status when on, the legacy /status route when off. Either way
// any other query params are preserved.
export default function AppealSubpathRedirect() {
  const { useToggleValue, TOGGLE_NAMES } = useFeatureToggle();
  const useVaTabs = useToggleValue(TOGGLE_NAMES.cstAppealDetailsVaTabs);
  const { id } = useParams();
  const { search } = useLocation();

  const to = useVaTabs
    ? `/appeals/${id}${searchWithTab(search, DEFAULT_APPEAL_TAB)}`
    : `/appeals/${id}/${DEFAULT_APPEAL_TAB}${search}`;
  return <Navigate to={to} replace />;
}
